import { render, staticRenderFns } from "./MaterialManagerContent.vue?vue&type=template&id=3a22babe&scoped=true"
import script from "./MaterialManagerContent.vue?vue&type=script&lang=js"
export * from "./MaterialManagerContent.vue?vue&type=script&lang=js"
import style0 from "./MaterialManagerContent.vue?vue&type=style&index=0&id=3a22babe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a22babe",
  null
  
)

export default component.exports